import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-6 ml-4 mb-20"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: " text-xl font-semibold text-gray-lp-300" }, "Area Delivery", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-300 text-sm font-semibold" }, " Detail 3LC & District ", -1)
const _hoisted_4 = { class: "rounded-lg overflow-hidden border max-w-max border-gray-lp-1400" }
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-lp-1400" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", { class: "text-gray-lp-300 text-sm font-semibold text-left bg-gray-lp-2500" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "No"),
    /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "3LC"),
    /*#__PURE__*/_createVNode("th", { class: "px-6 py-3" }, "District")
  ])
], -1)
const _hoisted_7 = { class: "divide-y divide-gray-lp-1400 bg-white" }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = {
  class: "flex flex-nowrap gap-2 overflow-hidden max-w-full pr-4",
  style: {"line-height":"24px","max-height":"24px"}
}
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "text-gray-lp-3000 text-sm" }
const _hoisted_15 = { class: "flex flex-wrap gap-2  p-2 rounded-lg border border-gray-lp-1400 max-h-80 overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_ctx.detailData?.partnerAreaDeliveries.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("table", _hoisted_5, [
            _hoisted_6,
            _createVNode("tbody", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData?.partnerAreaDeliveries, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: " text-gray-lp-300 text-sm"
                }, [
                  _createVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_9, _toDisplayString(item.cityCode || "-") + " - " + _toDisplayString(item.cityName || "-"), 1),
                  _createVNode("td", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList((item?.districts ?? []).slice(0, 2), (district) => {
                          return (_openBlock(), _createBlock("span", {
                            key: district.code,
                            class: "inline-block bg-gray-lp-2500 text-gray-lp-300 font-medium text-sm rounded-md px-2 py-1"
                          }, _toDisplayString((item?.districts?.length === 1)
                        ? (district.name || "-")
                        : ((district.name && district.name.length > 15)
                            ? district.name.slice(0, 15) + "..."
                            : (district.name || "-"))), 1))
                        }), 128))
                      ]),
                      ((item?.districts?.length || 0 ) > 1)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "button",
                            class: "ml-2 text-red-lp-100 text-sm font-semibold underline flex-shrink-0",
                            onClick: ($event: any) => (_ctx.openDistrictDialog(index))
                          }, _toDisplayString(_ctx.$t('LIHAT SEMUA')), 9, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_Dialog, {
          "model-value": _ctx.isShowDistrictDialog,
          title: _ctx.dialogTitle,
          "onUpdate:modelValue": _ctx.closeDistrictDialog,
          customWidth: "w-120"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('partnerManagement.districts')), 1),
              _createVNode("div", _hoisted_15, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogDistricts, (district, idx) => {
                  return (_openBlock(), _createBlock("span", {
                    key: idx,
                    class: "inline-block bg-gray-lp-2500 text-gray-lp-300 font-medium text-12px rounded-md px-3 py-1"
                  }, _toDisplayString(district.name || "-"), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["model-value", "title", "onUpdate:modelValue"])
      ]))
    : _createCommentVNode("", true)
}